<template>
  <div class="product" v-if="product.priceDisplay" data-growing-container :data-growing-idx="product.id" @click="viewProduct(product)">
<!--    <img  class="label-img" :src="product.labelImageUrl"/>-->
    <div style="padding-bottom: 16px; position: relative;">
      <image-with-loading :src="product.image" :width="1" :height="1" />
      <img class="label-corner" :src="product.labelImage.corner.imageUrl" @click="openLink(product.labelImage.corner.linkUrl)"
           v-if="product.labelImage && product.labelImage.corner && product.labelImage.corner.imageUrl" />
      <img class="label-banner" :src="product.labelImage.banner.imageUrl" @click="openLink(product.labelImage.banner.linkUrl)"
           v-if="product.labelImage && product.labelImage.banner && product.labelImage.banner.imageUrl" />
<!--      <img class="right-bottom-icon" src="@/assets/icons/3d.png" v-if="product.hasThreeDModel && appVersion && appVersion >= '1.8.0'"/>-->
    </div>

    <div style="padding-top: 16px">
      <!-- 新品 会员价 促销优惠 等tag-->
      <div class="labels" v-if="product.priceDisplay.tags">
        <div v-for="(tag, index) in product.priceDisplay.tags" :style="{color: '#' + tag.colorHex}" :key="index">{{tag.name}}</div>
      </div>
      <div class="name ellipsis">{{product.name}}</div>
      <div class="desc ellipsis">{{product.fullDescription || product.productType || ' '}}</div>

      <!-- 有效期的展示 -->
      <!--    <div-->
      <!--      class="desc"-->
      <!--      style="margin-top:5px;font-size: 11px"-->
      <!--      v-if="product.priceDisplay.promotionDescription"-->
      <!--    >{{product.priceDisplay.promotionDescription}}</div>-->

      <div class="price-container" v-bind:class="{ 'breath-taking': product.priceDisplay.currentPriceColorType === 'BTI' }">
        <!-- BTI 类型的商品 currentPriceColorHex 不生效 -->
        <div class="flex-left-align" style="align-items: flex-start;"
             :style="{color: '#' + (product.priceDisplay.currentPriceColorType === 'BTI' ? '111'
             : product.priceDisplay.currentPriceColorHex)}">
          <span
            style="font-size:10px; margin-top:3px; margin-right:1px;"
          >￥</span>
            <span class="price">
              {{getYuanStr(product.priceDisplay.currentPrice)}}
            </span>
          <span
            style="font-size:10px; margin-top:3px; margin-right:1px;"
          >.{{getFenStr(product.priceDisplay.currentPrice)}}</span>
          <span
            style="font-size: 12px; margin-top:6px; margin-left:2px;"
            v-if="product.priceDisplay.priceUnit"
          >/{{product.priceDisplay.priceUnit}}</span>
        </div>
      </div>
      <!-- 原价展示，originalPriceLineThrough 是否有划线效果，originalPriceTooltip 如 非会员价-->
      <div v-if="product.priceDisplay.originalPrice">
        <span
          class="desc"
          :class="{'line-through': product.priceDisplay.originalPriceLineThrough}"
        >¥{{formatPrice(product.priceDisplay.originalPrice)}}
          {{product.priceDisplay.priceUnit ? '/' + product.priceDisplay.priceUnit : ''}}
           {{product.priceDisplay.originalPriceTooltip}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  const cookie = require("@/libs/cookie");
  const router = require("@/libs/router");
  import ImageWithLoading from "@/components/ImageWithLoading";

  export default {
    props: ["product"],
    components: {
      ImageWithLoading
    },
    data() {
      return {
        appVersion: cookie.get("app_version")
      };
    },
    mounted() {

    },
    methods: {
      openLink(link) {
        if (link) {
          router.open("link", {
            link: {
              resolvedUrl: link
            }
          });
        }
      },
      viewProduct(product) {
        router.open('product', {
          id: product.id,
          type: product.itemType,
          seriesId: product.seriesId
        })
      },
      getYuanStr(price) {
        var result = '',
          counter = 0;
        var num = (price.toString().split(".")[0] || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
          counter++;
          result = num.charAt(i) + result;
          if (!(counter % 3) && i != 0) {
            result = ',' + result;
          }
        }
        return result;
      },
      getFenStr(price) {
        var arr = price.toString().split(".");
        if (arr.length > 1) {
          if (arr[1].length > 1) {
            return arr[1]
          } else {
            return arr[1] + "0"
          }
        }
        return "00";
      },
      formatPrice(price) {
        return this.getYuanStr(price) + "." + this.getFenStr(price)
      }
    }
  };
</script>

<style scoped>
  .product {
    /* border: 0.5px solid #f1f1f1; */
    padding: 16px;
    color: #111;
  }
  .breath-taking {
    background: #ffd800;
    padding: 1px 6px;
    -webkit-box-shadow: 2px 2px 0 0 #ef4123;
    box-shadow: 2px 2px 0 0 #ef4123;
  }
  .label-img {
    z-index: 100;
    height: 20px;
    width: auto;
    position: absolute;
    top: 20px;
    left: 0px;
  }
  .right-bottom-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 30px;
    height: 30px;
  }
  .labels {
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 6px;
    font-weight: bold;
  }
  .labels div {
    /*padding: 0 8px;*/
    /*border: 1px solid #f5f5f5;*/
    border-radius: 4px;
    margin-right: 10px;
  }
  .nlp-label {
    color: rgb(237, 2, 42);
  }
  .new-label {
    color: rgb(202, 80, 8);
  }
  .family-label {
    color: rgb(0, 110, 200);
  }
  .product .name {
    margin-top: 6px;
    font-size: 12px;
    font-weight: bold;
  }

  .product .desc {
    margin: 0px 0px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  .product .price-container {
    margin-top: 15px;
    display: inline-block;
    align-items: flex-start;
    font-weight: bold;
  }
  .product .price {
    font-size: 18px;
  }
  .line-through {
    text-decoration: line-through;
  }
  .label-banner {
    position: absolute;
    bottom: 0;
    left: -16px;
    width: 100%;
  }
  .label-corner {
    position: absolute;
    top: -16px;
    left: -16px;
    width: 80px;
    height: 80px;
  }
  .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue